import { DatePipe, DecimalPipe } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-telesuivi-graphique-hint-fuites',
  standalone: true,
  imports: [DecimalPipe, DatePipe],
  templateUrl: './telesuivi-graphique-hint-fuites.component.html',
  styleUrl: './telesuivi-graphique-hint-fuites.component.scss',
})
export class TelesuiviGraphiqueHintFuitesComponent {
  @Input() index: number = 0;
  @Input() fuitesList: Array<number> = [];
  @Input() dateList: Array<Date> = [];
}
